export default "__VITE_ASSET__CidY0fEe__"